const orderRo = {
    "total": "Total",
    "order_successfully_placed": "Comandă plasată",
    "empty_cart": "Coșul dvs. este momentan gol",
    "place_order": "Plasați comanda",
    "i_order": "Plasați comanda",
    "order_confirmation": "Confirmarea comenzii",
    "order_confirmation_msg_raw": "Prin plasarea comenzii, acceptați termenii și condițiile noastre de utilizare și politica noastră de confidențialitate, pe care le puteți găsi în <a href=\":link\" class=\"generated-link\" target=\"_blank\">linkul de mai jos</a>.",
    "status_PLACED": "Plasat",
    "status_ACCEPTED": "Acceptat",
    "status_SERVED": "Servit",
    "status_PAID": "Plătit",
    "empty_pending_orders": "Nu aveți comenzi în așteptare în acest moment",
    "overview": "Prezentare generală a comenzii",
    "note": "Nota",
    "items": "Articole",
    "review_order": "Prezentare generală"
};

export default orderRo;
